import React from 'react'
import { Col, Flex, IconButton, Row, Stack } from '@airbus/components-react/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FormInput from 'components/FormFields/FormInput'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { TechlogDetail } from 'types/techlog'
import { DisplayModus } from 'constants/constants'
import { useNavigate } from 'react-router-dom'
import { faBackward, faForward } from '@fortawesome/free-solid-svg-icons'

type Props = {
  displayMode: DisplayModus
  techlog: TechlogDetail | undefined
}

type TechlogDetailNavigator = TechlogDetail & {
  _date?: string
}

const TechlogNavigator = ({ displayMode, techlog }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const isNavPreviousEnabled = techlog?.prevCrm && displayMode === DisplayModus.READ
  const isNavNextEnabled = techlog?.nextCrm && displayMode === DisplayModus.READ

  const handleViewCrmPrevious = () => {
    const prevDateCrm =
      techlog?.prevDate &&
      techlog.prevDate?.substring(6) + techlog.prevDate.substring(3, 5) + techlog.prevDate.substring(0, 2)
    navigate(`/amasis-web/techlogs/${techlog?.avimmatr}/${prevDateCrm}/${techlog?.prevCrm}`)
  }

  const handleViewCrmNext = () => {
    const nextDateCrm =
      techlog?.nextDate &&
      techlog.nextDate?.substring(6) + techlog.nextDate.substring(3, 5) + techlog.nextDate.substring(0, 2)
    navigate(`/amasis-web/techlogs/${techlog?.avimmatr}/${nextDateCrm}/${techlog?.nextCrm}`)
  }

  const methods = useForm<TechlogDetailNavigator>({
    values: {
      ...techlog,
      _date:
        techlog?.rmdate &&
        ('0' + techlog?.rmdate[2]).slice(-2) + '/' + ('0' + techlog?.rmdate[1]).slice(-2) + '/' + techlog?.rmdate[0],
    },
  })

  return (
    <>
      <FormProvider {...methods}>
        <form style={{ marginTop: '1em' }}>
          <Stack direction='row'>
            <Flex spacing='2-x' justify='space-around'>
              <FormInput name='avimmatr' label={t('9500031') as string} readOnly />
              <FormInput name='_date' label={t('9500034') as string} readOnly />
              <FormInput
                name='rmdoc'
                label={(techlog?.rmdoc === techlog?.lastCrm ? t('9500172') : t('0MOE065')) || undefined}
                readOnly
              />
              <FormInput name='fh' label={t('0MBO012') as string} readOnly style={{ textAlign: 'center' }} />
              <FormInput name='cycle' label={t('0MRM024') as string} readOnly />
            </Flex>
          </Stack>

          {displayMode === DisplayModus.READ && (
            <Row alignItems='center' style={{ textAlign: 'center' }}>
              <Col xxs={6}>
                <IconButton
                  title={t('pagination_previous') as string}
                  style={{ height: '2em' }}
                  disabled={!isNavPreviousEnabled}
                  onClick={isNavPreviousEnabled ? handleViewCrmPrevious : () => {}}
                  variant='ghost'
                >
                  <FontAwesomeIcon icon={faBackward} />
                </IconButton>
              </Col>
              <Col xxs={6}>
                <IconButton
                  title={t('pagination_next') || undefined}
                  style={{ height: '2em' }}
                  disabled={!isNavNextEnabled}
                  onClick={isNavNextEnabled ? handleViewCrmNext : () => {}}
                  variant='ghost'
                >
                  <FontAwesomeIcon icon={faForward} />
                </IconButton>
              </Col>
            </Row>
          )}
        </form>
      </FormProvider>
    </>
  )
}

export default TechlogNavigator
